import React from 'react';

import i18n from 'Utilities/i18n';

const ContinueSharing: React.FC = () => {
  return (
    <span id="continue-sharing-text" className="mt-4 mb-2 text-black-50 text-md">
      {i18n.t('PartnersGeneric.continueSharingInstructions')}
    </span>
  );
};

export default ContinueSharing;
